import type {ComponentProps, FC} from 'react';
import {Theme} from '@wellstone-solutions/common';
import {Avatar} from '@wellstone-solutions/web';
import {initialsOf} from 'utils/initialsOf';

type AvatarProps = ComponentProps<typeof Avatar>;

type InitialsAvatarProps = Omit<AvatarProps, 'children'> & {
  name?: string | null;
  // Diameter in px. Font size scales with it unless overridden in `sx`.
  size?: number;
};

export const InitialsAvatar: FC<InitialsAvatarProps> = ({
  name,
  size = 40,
  sx,
  ...props
}) => (
  <Avatar
    {...props}
    sx={[
      {
        width: size,
        height: size,
        fontSize: Math.round(size * 0.4),
        fontWeight: 700,
        bgcolor: Theme.colorPalette.primary4,
        color: Theme.colorPalette.primary,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}>
    {initialsOf(name)}
  </Avatar>
);
